export default {
  data: {
    enabled_features: [],
    global_features: [
      'browse_courses',
      'bypass_email_format_for_invites',
      'confirmation_required',
      'edit_name',
      'edit_email',
      'global_gallery',
      'messenger',
      'public_browse',
      'public_portfolio',
      'registration'
    ],
    course_features: [
      'archive_access',
      'assign_course_creator_role',
      'autocomplete_students_on_course_invites',
      'course_withdraw',
      'default_hide_due_dates',
      'instructor_enrollment_management',
      'global_invite_only',
      'public_syllabus_page',
      'publish_approval_required',
      'show_instructor_emails_on_syllabus'
    ],
    account_email: '',
    app_name: '',
    email_format: '',
    email_host: '',
    showSyllabusWarning: false,
    authentication_options: {
      email: {
        enabled: true
      },
      google: {
        enabled: false,
        client_key: null,
        secret_key: null
      },
      facebook: {
        enabled: false,
        app_id: null,
        app_secret: null
      },
      github: {
        enabled: false,
        client_id: null,
        client_secret: null
      },
      auth0: {
        enabled: false,
        client_id: null,
        client_secret: null,
        domain: null
      },
      azure_activedirectory_v2: {
        enabled: false,
        client_id: null,
        client_secret: null,
        tenant_id: null
      },
      clever: {
        enabled: false,
        client_id: null,
        client_secret: null,
        redirect_uri: null
      }
    },
    basicSettings: [
      'account_email',
      'app_name',
      'email_format',
      'email_host',
    ],
  },

  watch: {
    enabled_features(curr, last) {
      if (
        !_.includes(last, 'public_syllabus_page') &&
        _.includes(curr, 'public_syllabus_page')
      ) {
        this.showSyllabusWarning = true;
      } else if (
        _.includes(last, 'public_syllabus_page') &&
        !_.includes(curr, 'public_syllabus_page')
      ) {
        this.showSyllabusWarning = false;
      }
    }
  },

  computed: {
    disabled_features() {
      return _.difference(this.global_features.concat(this.course_features), this.enabled_features);
    },

    auth_options_enabled() {
      return _.where(this.authentication_options, {enabled: true});
    },
  },

  methods: {
    bindData(data) {
      this.enabled_features = data.features.enabled || [];
      this.basicSettings.forEach(attr => this[attr] = data[attr]);
      this.authentication_options = data.authentication_options;
      this.$nextTick(() => this.showSyllabusWarning = false );
    },

    checkAllowedChange(_val, evt) {
      if (!evt.currentTarget.checked && this.auth_options_enabled.length == 1) {
        evt.stopPropagation();
        evt.preventDefault();

        Kadenze.UIUtil.displayMessage(
          'Error',
          'You must select at least one authentication method.'
        );

        return false;
      }
    },

    featureLabel(feature) {
      return I18n.t('admin.settings.features.' + feature);
    },

    featureHelpText(feature) {
      return I18n.t('admin.settings.features.helptext.' + feature);
    },

    promptAndSave() {
      if (this.showSyllabusWarning) {
        const prompt = 'It looks like you\'re currently using the "' +
                       'drag and drop syllabus builder", ' +
                       'which is incompatible with the "promotional course info page". ' +
                       'By turning on the promotional course info page, ' +
                       'you will lose any syllabi created using the drag and ' +
                       'drop syllabus builder and will have to rebuild your syllabi ' +
                       'using the promotional course info page compatible syllabus editor. ' +
                       'Are you sure you want to save?';

        Kadenze.UIUtil.confirmAction(prompt, this.save);
      } else {
        this.save();
      }
    },

    save() {
      let data = this.serializeData();

      let req = new Kadenze.AjaxRequest({
        type: 'PATCH',
        data: data,
        url: Kadenze.Routes.admin_update_settings_path(),
        loadingIndicator: true
      });

      req.done(function(response) {
        new Kadenze.Notice.success({ message: response.message });
      });

      req.fail((xhr) => {
        new Kadenze.Notice.error({ message: xhr.responseText });
      });

      this.showSyllabusWarning = false;
    },

    serializeData() {
      let data = {
        settings: {
          features: {
            disabled: this.disabled_features,
            enabled: this.enabled_features
          }
        },
        authentication_options: this.authentication_options
      };

      this.basicSettings.forEach(attr => data.settings[attr] = this[attr]);

      return data;
    },
  },

  created() {
    if (Kadenze.isKannu && RAILS_ENV == 'prod') {
      this.global_features = _.without(this.global_features, 'global_gallery');
    }
  }
};
